/*jshint camelcase: false */
/* global _:false, moment:false, console:false */
var RoomRatePricing;

(function () {
    'use strict';

    /**
     * New Backend Bookings Rate Pricing Module
     *
     * This script manages pricing of rates (and therefore rooms). It should calculate prices without having to go to
     * the server but relies on dates not changing. Changed dates means re-fetching data.
     *
     * This is a reasonably simple object but is separated as this logic can be a little confusing
     */
    RoomRatePricing = {

        /**
         * @param rateDetails object
         * @param paxConfiguration object
         * @param dateRange object - moment.range() object with correct date times
         * @param period mixed
         * @param {Object} strictData
         */
        getPerPeriodAndTotalPrice: function(rateDetails, paxConfiguration, dateRange, period, strictData) {
            // Get the number of "periods"
            var periods = this.calculatePeriodsInDuration(dateRange, period),
                // And then the price of the whole thing
                pricePerPeriod = this.getPricePerPeriod(rateDetails, paxConfiguration, dateRange, period, strictData);

            // Return the per period price, and a convenience total which will just be the per-period multiplied by the
            // number of periods
            return {
                perPeriod: pricePerPeriod.price,
                periods: periods,
                total: pricePerPeriod.price * periods,
                description: pricePerPeriod.description
            };
        },

        getFormattedPerPeriodAndTotalPrice: function(rateDetails, paxConfiguration, dateRange, period, overridePerPeriod, strictData) {
            var prices = this.getPerPeriodAndTotalPrice(rateDetails, paxConfiguration, dateRange, period, strictData),
                perPeriod = typeof prices.perPeriod !== 'number' || _.isNaN(prices.perPeriod) ? false : $.moneyFormat(prices.perPeriod, false, true, true),
                rateToUse = false, total = false, rawTotal = false, alternatePerPeriod = false, alternateTotal = false;

            if(!_.isNaN(overridePerPeriod)) {
                rateToUse = overridePerPeriod;
            }
            else if(perPeriod !== false) {
                rateToUse = prices.perPeriod;
            }

            if(rateToUse !== false && rateToUse !== null) {
                rawTotal = rateToUse * prices.periods;
                total = $.moneyFormat(rawTotal, false, true, true)
            }
            else {
                total = rateToUse;
            }

            if(prices.description.info.alternatePricePerPeriod !== null) {
                alternatePerPeriod = prices.description.info.alternatePricePerPeriod;
                alternateTotal = prices.description.info.alternatePricePerPeriod * prices.periods;
            }

            return {
                perPeriod: perPeriod,
                alternatePerPeriod: alternatePerPeriod ? $.moneyFormat(alternatePerPeriod, false, true, true) : null,
                total: total,
                alternateTotal: alternateTotal ? $.moneyFormat(alternateTotal, false, true, true) : null,
                raw: {
                    perPeriod: prices.perPeriod,
                    alternatePerPeriod: alternatePerPeriod,
                    total: rawTotal,
                    alternateTotal: alternateTotal
                },
                periods: prices.periods,
                description: prices.description
            }
        },

        getPricePerPeriod: function(rateDetails, paxConfiguration, dateRange, period, strictData) {
            // Validate pax configurations
            if(!this._validatePaxDetails(paxConfiguration)) {
                console.error('Invalid pax configuration object', paxConfiguration);
                return false;
            }

            var nights = this.calculatePeriodsInDuration(dateRange, 1),
                // And the pax configuration we'll actually be pricing for
                paxCounts = this.getPaxConfigurationToPriceFor(rateDetails.basePax, paxConfiguration),
                // Set a default price of null
                price = null,
                // Start a response object that will describe how the pricing was calculated
                description = {
                    errors: [],
                    warnings: [],
                    info: {
                        nights: [],
                        message: '',
                        alternatePricePerPeriod: null
                    }
                },
                // And some pre-declared vars for the following loop:
                errored = false,
                bestMinStay, validChildRate, paxPrices, basePaxRemaining, pricedAs, priceOnNight, rateComponents,
                isPackageRate = false, bestPossiblePrice;

            // Check some strict rules if we're given them
            if (strictData !== undefined) {
                if (strictData.maxStay !== null && strictData.maxStay < rateDetails.length) {
                    description.warnings.push('Selected date range exceeds the maximum stay rule on the rate (' +
                        strictData.maxStay + ' nights).');
                }

                if (
                    strictData.pax.min !== null &&
                    paxConfiguration.count(!strictData.paxRule.infants, !strictData.paxRule.children) < strictData.pax.min
                ) {
                    description.warnings.push('Selected pax does not meet the minimum pax requirement on the rate (' +
                        strictData.pax.min + ')');
                }
            }

            // Now we loop the rate details. This is an array of separate objects for each day that is being priced.
            $.each(rateDetails, $.proxy(function(i, details) {
                // Get the best min stay in the pricing
                bestMinStay = this._resolveBestMinStayInDetails(details, nights); // TODO fix to always use nights
                // If we don't have a best min stay then we have no price
                if (!bestMinStay) {
                    bestMinStay = this._findSmallestValidMinStay(details);
                    if (period !== 10) {
                        // This is an error if we're not a sub-nightly (ie. hourly) rate type
                        description.errors.push('No minimum nights stay valid for dates');
                        // Create a message for the smallest min stay required
                        description.info.message = 'This rate has no price for the selected date range. The smallest ' +
                            'minimum stay is ' + bestMinStay + ' nights.';
                        errored = true;
                    }

                    // Check if there is any min stays at all...
                    if (!bestMinStay) {
                        // ... and bail out if there is none
                        description.info.alternatePricePerPeriod = null;
                        return {
                            price: null,
                            description: description
                        }
                    }
                }

                // Reset the base pax remaining
                basePaxRemaining = details.basePax - paxCounts.adults;
                if(basePaxRemaining < 0) {
                    basePaxRemaining = 0;
                }

                // Refine the details to be the prices out of our details array
                details = details['minStays'][bestMinStay];

                // Check if rate details has a package price
                isPackageRate = typeof details['basePackagePrice'] !== 'undefined';

                // Check if the child rate is valid for this date
                validChildRate = typeof details !== 'undefined' ? details.hasChildRate : null;

                // Make sure that the price is no longer null
                if(price === null) {
                    price = 0;
                }
                
                // Reset daily price
                priceOnNight = 0;

                // And the object that holds the pax amounts that are used for pricing (which may differ from actual
                // pax counts)
                pricedAs = {
                    adults: 0,
                    children: 0,
                    infants: 0
                };
                rateComponents = {};

                // Now loop the pax configuration to price each amount of pax
                $.each(paxCounts, $.proxy(function(paxType, paxCount) {
                    // Continue if the amount of pax is zero
                    if(paxCount === 0) {
                        return true;
                    }

                    // Custom logic for child rates
                    if(paxType === 'children') {
                        // First force the pax type to adult if we're dealing with children and there is no valid child
                        // rate
                        if(!validChildRate) {
                            pricedAs['adults'] += paxCount;
                        }
                        // If we do have a chile rate, then we'll make sure any children are priced as adults to fill
                        // the base pax first
                        else {
                            // Add the base pax remaining to the adults
                            pricedAs['adults'] += basePaxRemaining;
                            // If we have more children than the base pax left, we'll price the rest as children
                            if(paxCount > basePaxRemaining) {
                                pricedAs['children'] += (paxCount - basePaxRemaining);
                            }
                            // Adjust the base pax remaining
                            basePaxRemaining -= paxCount;
                            if(basePaxRemaining < 0) {
                                basePaxRemaining = 0;
                            }
                        }
                        // And we've update the pricedAs array manually, so we can just continue here.
                        return true;
                    }
                    // For infants, if there's no infant rate, they're free
                    if(paxType === 'infants' && !details.hasInfantRate) {
                        return true;
                    }

                    pricedAs[paxType] += paxCount;
                }, this));

                $.each(pricedAs, function(paxType, paxCount) {
                    if(paxCount === 0) {
                        return true;
                    }

                    paxPrices = null;
                    if(isPackageRate && i < bestMinStay) {
                        // Extract the prices for a package rate
                        paxPrices = typeof details !== 'undefined' ? details['packagePrices'] : null;
                    }

                    if(paxPrices === null) {
                        // Extract the prices we have for this pax
                        paxPrices = typeof details !== 'undefined' ? details[paxType + 'Prices'] : null;
                    }

                    if(paxPrices) {
                        // Fetch the best possible price for the current pax
                        bestPossiblePrice = paxPrices[paxCount];
                        // If it a package rate then fetch best possible fixed price for the current min stay
                        if(isPackageRate && i < bestMinStay) {
                            bestPossiblePrice = bestPossiblePrice / bestMinStay;
                        }

                        // And add the cost of the number of pax we have to the overall price
                        priceOnNight += bestPossiblePrice;
                        // Keep track of what price for each pax type is being used
                        rateComponents[paxType] = paxPrices[paxCount] || false;
                    }
                });

                // Keep track of the price for each night, and the pax that the rate is actually considering when
                // pricing
                description.info.nights.push({
                    price: priceOnNight || false,
                    pricedAs: pricedAs,
                    breakdown: rateComponents
                });

                if(_.isNaN(priceOnNight)) {
                    description.errors.push('Rate does not fit the pax provided');
                    price = null;
                    return false;
                }

                price += priceOnNight;
            }, this));

            price = price === null ? null : price / rateDetails.length;

            if(errored) {
                description.info.alternatePricePerPeriod = price;
                price = null;
            }

            if(!description.info.message.length) {
                description.info.message = description.warnings.join('\n');
            }

            return {
                price: price,
                description: description
            };
        },

        calculatePeriodsInDuration: function(dateRange, periodType) {
            return dateRange.periods().period(periodType);
        },

        /**
         * Re-distributes the pax from the given paxConfiguration object so that you are left with just the pax counts
         * that matter for pricing. Ie. folds superfluous children up into the adult pax count.
         *
         * @param rateBasePax
         * @param paxConfiguration
         */
        getPaxConfigurationToPriceFor: function(rateBasePax, paxConfiguration) {
            // Prepare some variables for determining how many pax of each type are required
            var additionalPaxNeeded, paxCount,
                newPaxCounts = {
                    adults: 0,
                    children: 0,
                    infants: 0
                };

            // Loop through the pax types
            $.each(['adults', 'children', 'infants'], $.proxy(function(paxConfiguration, i, paxType) {
                // Get the pax count
                paxCount = paxConfiguration[paxType];
                // If there is no count, then just continue to the next pax type
                if(paxCount === 0) {
                    if(paxType === 'adults') {
                        additionalPaxNeeded = rateBasePax;
                    }
                    return true;
                }
                // Check if we have any "additional pax needed" to fill a base pax of a previous type
                if(additionalPaxNeeded > 0) {
                    // Default to base pax as this always must be fulfilled. Fixes no adult pricing issues
                    if(newPaxCounts.adults === 0) {
                        newPaxCounts.adults = rateBasePax;
                    }

                    // Try to satisfy this condition with the amount of pax we have here
                    additionalPaxNeeded -= paxCount;
                    // If we still need additional pax, or we have completely satisfied the additional pax, we
                    // can continue to the next pax type
                    if(additionalPaxNeeded >= 0) {
                        return true;
                    }
                    // Otherwise, additional pax needed is now a negative value that refers to the amount of extra
                    // pax we have
                    paxCount = Math.abs(additionalPaxNeeded);
                }

                // Only if this is adult pax count, we have to check that the base pax is satisfied.
                if(paxType === 'adults') {
                    // Check that this pax count is enough, otherwise we need addtional pax
                    if(paxCount < rateBasePax) {
                        // The base pax will be the number of adults considered for the price
                        newPaxCounts.adults = rateBasePax;
                        additionalPaxNeeded = rateBasePax - paxCount;
                    }
                    else {
                        // Save the number of adults
                        newPaxCounts.adults = paxCount;
                    }
                }
                else {
                    newPaxCounts[paxType] += paxCount;
                }
            }, this, paxConfiguration));

            return newPaxCounts;
        },

        buildPaxConfiguration: function(adults, children, infants) {
            if(adults === undefined || _.isNaN(parseInt(adults, 10))) {
                adults = 0;
            }
            if(children === undefined || _.isNaN(parseInt(children, 10))) {
                children = 0;
            }
            if(infants === undefined || _.isNaN(parseInt(infants, 10))) {
                infants = 0;
            }
            return {
                adults: parseInt(adults, 10),
                children: parseInt(children, 10),
                infants: parseInt(infants, 10),
                // Add a method to the pax object to return a count
                count: function(excludeInfants, excludeChildren) {
                    return this.adults + (excludeChildren ? 0 : this.children) + (excludeInfants ? 0 : this.infants);
                }
            };
        },

        _resolveBestMinStayInDetails: function(details, numNights) {
            var bestMinStay = null;

            // Loop through the valid min stays until we find a price
            $.each(details.minStays, function (minStay, minStayDetails) {
                minStay = parseInt(minStay);
                if (minStay <= numNights &&
                    (bestMinStay === null || minStay > bestMinStay) &&
                    minStayDetails !== null &&
                    minStayDetails['basePrice'] !== null
                ) {
                    bestMinStay = minStay;
                }
            });

            return bestMinStay;
        },

        _findSmallestValidMinStay: function(details) {
            var smallestMinStay = null;

            $.each(details.minStays, function(minStay, minStayDetails) {
                minStay = parseInt(minStay);
                if((smallestMinStay === null || minStay < smallestMinStay) &&
                    minStayDetails !== null &&
                    minStayDetails['basePrice'] !== null
                ) {
                    smallestMinStay = minStay;
                }
            });

            return smallestMinStay;
        },

        _detailsHasChildPricing: function(details) {
            return details.prices.children !== undefined;
        },

        _detailsHasInfantPricing: function(details) {
            return details.prices.infants !== undefined;
        },

        _validatePaxDetails: function(paxDetails) {
            // Check that we have an object
            return typeof paxDetails === 'object' &&
                // Check it has 3 properties
                _.keys(_.omit(paxDetails, _.functions(paxDetails))).length === 3 &&
                // And that the 3 properties are "adults", "children" and "infants"
                paxDetails.hasOwnProperty('adults') && paxDetails.hasOwnProperty('children') && paxDetails.hasOwnProperty('infants');
        }
    };
})();
